import { useEffect, useState } from "react" 
import Cover from "./Cover"
import { ITestsStore, useTestsStore } from "../../data/store"
import { IPETest, defaultTest } from "../../data/interfaces"
import { Navigate, Route, Routes } from "react-router"
import TestGenerator from "./TestGenerator"
import Question from "./Question"
import Finish from "./Finish"
//import { useBlocker } from "react-router/dist/lib/hooks"
import { Json } from "src/libs/interfaces/layouts"
import useGenTest from "../../hooks/useGenTest"
import TestContainer from "./TestContainer"

const TestGeneratorForm = ( ): JSX.Element => {
    const genTest: IPETest = useGenTest() 
    const [json, setJson] = useState<Json>("")
    useEffect(() => { 
    if(!genTest.title){
            useTestsStore.setState({genTest: defaultTest(), genStep: 0})
        }
        setJson( JSON.stringify(genTest))
    }, [])
    return <>
        <Routes>
            <Route element={<TestGenerator />} >
                <Route path=":testId" element={<TestContainer />}>
                    <Route index element={<Navigate to="cover" />} /> 
                    <Route path="cover" element={<Cover />} />
                    <Route path=":question_id" element={<Question />} />
                    <Route path="finish" element={<Finish />} />
                </Route>
            </Route>
        </Routes>
    </>
}

export default TestGeneratorForm